module.exports = "/_next/static/images/Serghei_Busmachiu-cf0ef9b8a2a45b43dd049de741d97586.webp";